import {
  AdminBillingFailedTransactionsPath,
  AdminBillingHomePath,
  AdminBillingInvoiceDetailsPath,
  AdminBillingInvoiceListPath,
  AdminBillingPricesPath,
  AdminStoreListPath,
  OrganizationAddPath,
  OrganizationEditPath,
  OrganizationListPath,
  RetailerAddPath,
  RetailerEditPath,
  RetailerListPath,
  RetailerStoreAddPath,
  RetailerStoreEditAddressPath,
  RetailerStoreEditPath,
  RetailerStoreListPath,
  StoreEditAddressPath,
  StoreEditPath,
  SupplierAddPath,
  SupplierEditPath,
  SupplierEditSectionPath,
  SupplierListPath,
  SupplierToRetailerAddPath,
  SupplierToRetailerListPath,
  SupplierToStoreAddPath,
  SupplierToStoreListPath,
  UserAddPath,
  UserEditPath,
  UserListPath,
} from '@/modules/admin/paths';
import { HomePath } from '@/routing/paths';

const home = { label: 'Home', path: HomePath };

const billingHome = { label: 'Billing', path: AdminBillingHomePath };
const billingFailedTransactions = {
  label: 'Failed Transactions',
  path: AdminBillingFailedTransactionsPath,
};
const billingInvoiceList = { label: 'Invoices', path: AdminBillingInvoiceListPath };
const billingInvoiceDetails = {
  label: 'Invoice details',
  path: AdminBillingInvoiceDetailsPath.path,
};
const billingPrices = { label: 'Prices', path: AdminBillingPricesPath };
const adminStoreList = { label: 'Stores', path: AdminStoreListPath };
const organizationList = { label: 'Organizations', path: OrganizationListPath };
const organizationAdd = { label: 'Add', path: OrganizationAddPath };
const organizationEdit = { label: 'Edit', path: OrganizationEditPath.path };
const retailerList = { label: 'Retailers', path: RetailerListPath };
const retailerAdd = { label: 'Add', path: RetailerAddPath };
const retailerEdit = { label: 'Edit', path: RetailerEditPath.path };
const supplierList = { label: 'Suppliers', path: SupplierListPath };
const supplierAdd = { label: 'Add', path: SupplierAddPath };
const supplierEdit = { label: 'Edit', path: SupplierEditPath.path };
const userList = { label: 'Users', path: UserListPath };
const userAdd = { label: 'Add', path: UserAddPath };
const userEdit = { label: 'Edit', path: UserEditPath.path };
const retailerStoreList = { label: 'Stores', path: RetailerStoreListPath.path };
const retailerStoreAdd = { label: 'Create', path: RetailerStoreAddPath.path };
const retailerStoreEdit = { label: 'Edit', path: RetailerStoreEditPath.path };
const adminStoreEdit = { label: 'Edit', path: StoreEditPath.path };
const supplierToRetailerList = { label: 'Retailers', path: SupplierToRetailerListPath.path };
const supplierToRetailerAdd = { label: 'Link', path: SupplierToRetailerAddPath.path };
const supplierToStoreList = { label: 'Stores', path: SupplierToStoreListPath.path };
const supplierToStoreAdd = { label: 'Link', path: SupplierToStoreAddPath.path };

const breadcrumbs = [
  {
    path: AdminBillingHomePath,
    items: [home, billingHome],
  },
  {
    path: AdminBillingInvoiceListPath,
    items: [home, billingHome, billingInvoiceList],
  },
  {
    path: AdminBillingInvoiceDetailsPath.path,
    items: [home, billingHome, billingInvoiceList, billingInvoiceDetails],
  },
  {
    path: AdminBillingPricesPath,
    items: [home, billingHome, billingPrices],
  },
  {
    path: AdminBillingFailedTransactionsPath,
    items: [home, billingHome, billingFailedTransactions],
  },
  {
    path: AdminStoreListPath,
    items: [home, adminStoreList],
  },
  {
    path: StoreEditPath.path,
    items: [home, adminStoreList, adminStoreEdit],
  },
  {
    path: StoreEditAddressPath.path,
    items: [home, adminStoreList, adminStoreEdit],
  },
  {
    path: OrganizationListPath,
    items: [home, organizationList],
  },
  {
    path: OrganizationAddPath,
    items: [home, organizationList, organizationAdd],
  },
  {
    path: OrganizationEditPath.path,
    items: [home, organizationList, organizationEdit],
  },
  {
    path: RetailerListPath,
    items: [home, retailerList],
  },
  {
    path: RetailerAddPath,
    items: [home, retailerList, retailerAdd],
  },
  {
    path: RetailerEditPath.path,
    items: [home, retailerList, retailerEdit],
  },
  {
    path: RetailerStoreListPath.path,
    items: [home, retailerList, retailerEdit, retailerStoreList],
  },
  {
    path: RetailerStoreAddPath.path,
    items: [home, retailerList, retailerEdit, retailerStoreList, retailerStoreAdd],
  },
  {
    path: RetailerStoreEditPath.path,
    items: [home, retailerList, retailerEdit, retailerStoreList, retailerStoreEdit],
  },
  {
    path: RetailerStoreEditAddressPath.path,
    items: [home, retailerList, retailerEdit, retailerStoreList, retailerStoreEdit],
  },
  {
    path: SupplierListPath,
    items: [home, supplierList],
  },
  {
    path: SupplierAddPath,
    items: [home, supplierList, supplierAdd],
  },
  {
    path: SupplierEditPath.path,
    items: [home, supplierList, supplierEdit],
  },
  {
    path: SupplierEditSectionPath.path,
    items: [home, supplierList, supplierEdit],
  },
  {
    path: UserListPath,
    items: [home, userList],
  },
  {
    path: UserAddPath,
    items: [home, userList, userAdd],
  },
  {
    path: UserEditPath.path,
    items: [home, userList, userEdit],
  },
  {
    path: SupplierToRetailerListPath.path,
    items: [home, supplierList, supplierEdit, supplierToRetailerList],
  },
  {
    path: SupplierToRetailerAddPath.path,
    items: [home, supplierList, supplierEdit, supplierToRetailerList, supplierToRetailerAdd],
  },
  {
    path: SupplierToStoreListPath.path,
    items: [home, supplierList, supplierEdit, supplierToStoreList],
  },
  {
    path: SupplierToStoreAddPath.path,
    items: [home, supplierList, supplierEdit, supplierToStoreList, supplierToStoreAdd],
  },
];

export default breadcrumbs;
